module.exports = __webpack_public_path__ + "3ab1866820ab28166dfa9f90eecdaf52.svg";